import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-bsc-finance-colleges-nagpur',
  templateUrl: './top-bsc-finance-colleges-nagpur.component.html',
  styleUrls: ['./top-bsc-finance-colleges-nagpur.component.scss']
})
export class TopBscFinanceCollegesNagpurComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
